import React from 'react';

const MenuPage = ({children, title, onBackClick, menu}) => (
    <div>
        <div style={{padding: '20px'}}>
        {children}
        </div>
    </div>
);

export default MenuPage;

export const MenuPageHoc = Component => props =>
    <MenuPage {...props}>
        <Component {...props} />
    </MenuPage>



// WEBPACK FOOTER //
// ./src/pages/MenuPage.js